// extracted by mini-css-extract-plugin
var _1 = "ProvisionEntitySearchPostPill-module__icon--h1jAa";
export { _1 as "icon" }
